let helper = require('./helper');
module.exports = {
    init: function (currentSlide) {
        let that = this;

        /*Create events*/
        helper.createEvents(['anotherSlideViewed']);

        this.currentSlideInViewNumber = undefined;
        this.currentSlide = currentSlide;
        window.fpEventsData = window.fpEventsData || {};
        window.fpEventsData.anotherSlideViewed = {
            slideInViewNumber: this.currentSlideInViewNumber
        };

        window.onpopstate = function (event) {
            if (event.state) {
                that.currentSlideInViewNumber = undefined;
                window.fpEventsData.anotherSlideViewed.slideInViewNumber = undefined;
            }
        };
        helper.addEvent(window, 'slideScrolling', () => {
            that._updateGlobalDataAndFireEventIfNeeded();
        });
    },
    _updateGlobalDataAndFireEventIfNeeded: function () {
        let that = this;
        let numberOfHighestSeparatorWithinViewport = this._getNumberOfHighestSeparatorWithinViewport({
            currentSlide: that.currentSlide,
            distanceFromTopEdge: 100
        });
        if (numberOfHighestSeparatorWithinViewport === undefined) return;
        let slideInViewNumber = numberOfHighestSeparatorWithinViewport;

        if (this.currentSlideInViewNumber !== slideInViewNumber) {
            this.currentSlideInViewNumber = slideInViewNumber;
            window.fpEventsData.anotherSlideViewed.slideInViewNumber = slideInViewNumber;
            window.dispatchEvent(helper.getEventByName('anotherSlideViewed'));
        }
        // window.addEventListener('anotherSlideViewed', () => {console.log(window.fpEventsData.anotherSlideViewed)})
    },
    _getNumberOfHighestSeparatorWithinViewport: function (params) {
        if (params.currentSlide === undefined) return;
        let separatorElements = params.currentSlide.querySelectorAll('.fp-slide-separator');
        if (separatorElements.length === 0) return;
        let separators = [];
        for (let i = 0; i < separatorElements.length; i++) {
            let separatorElement = separatorElements[i];
            separators.push({
                number: separatorElement.dataset.n,
                offsetTop: helper.getElementViewportOffset(separatorElement).top
            });
        }

        let separatorsBellowTopEdge = separators.filter(separator => (separator.offsetTop > params.distanceFromTopEdge));
        let heightsSeparator;
        let lowestSeparator;
        if(separatorsBellowTopEdge.length) {
            heightsSeparator = separatorsBellowTopEdge.reduce((prevSep, currSep) => {
                if (prevSep) {
                    return currSep.offsetTop < prevSep.offsetTop ? currSep : prevSep;
                }
            });
        }else{
            // find lowest one we have
            lowestSeparator = separators.reduce((prevSep, currSep) => {
                if (prevSep) {
                    return currSep.offsetTop > prevSep.offsetTop ? currSep : prevSep;
                }
            });
        }

        if(heightsSeparator){
            return heightsSeparator.number;
        }else{
            return lowestSeparator.number;
        }
    }
};